import { Message } from "#/components/messaging/inAppMessagingTypes"
import { getCarrotPlanMessageDismissTimestamp } from "#/components/views/modal/utils/localStorageUtils"

export const useMessageDisplayState = (cpMessage: Message): boolean => {
  const lastDismissTimestamp = getCarrotPlanMessageDismissTimestamp()
  const messageTimestamp = new Date(cpMessage?.createdAt || 0).getTime()

  return !lastDismissTimestamp || messageTimestamp > lastDismissTimestamp
}
